const enrolments = {
	title: "Påmeldinger",
	title_org: "Bedrifter",
	title_companies: "Bedrift",
	new_enrolment: "Ny påmelding",
	edit_enrolment: "Rediger påmelding: {name}",
	view_enrolment: "Vis påmelding: {name}",
	create_enrolment_org: "Opprett bedrift",
	view_enrolment_org: "Bedrift: {name}",
	edit_enrolment_org: "Bedrift: {name}",
	list_title: "Påmeldinger",
	list_title_org: "Bedriftspåmeldinger",
	list_subtitle: "Håndter påmeldinger",
	list_subtitle_org: "Håndter påmeldte bedrifter",
	create_title: "Meld på",
	update_title: "Oppdater påmelding",
	details_title: "Påmeldingsdetaljer",
	address_title: "Adresse",
	id: "ID",
	visiting_address: "Besøksadresse",
	invoice_address: "Fakturaadresse",
	participants: "Deltakere",
	course: "Kurs",
	name: "Navn",
	number: "Nummer",
	p_first_name: "Fornavn",
	p_last_name: "Etternavn",
	p_email: "Epost",
	p_mobile: "Mobil",
	p_date_of_birth: "Født",
	p_address_street: "Gate",
	p_address_city: "By/Sted",
	p_address_state: "Fylke",
	p_address_zip: "Postnr",
	p_address_country: "Land",
	p_image: "Bilde",
	p_company: "Selskap",
	invoice_email: "Faktura epost",
	enrolled: "Påmeldt",
	dept_chief: "Avdelingsleder",
	o_vat: "Orgnr",
	o_name: "Firmanavn",
	o_reference: "Referanse/PO",
	o_requestor: "Bestillers",
	o_first_name: "Bestillers fornavn",
	o_last_name: "Bestillers etternavn",
	o_email: "Bestillers epost",
	o_date_of_birth: "Født",
	o_address_street: "Gate",
	o_address_city: "By/Sted",
	o_address_state: "Fylke",
	o_address_zip: "Postnr",
	o_address_country: "Land",
	employeed_from: "Notat",
	comment: "Kommentar",
	internal_notes: "Interne notater",
	no_of_participants: "Antall deltagere",
	verify_title: "Lignende deltager/elev finnes allerede i registeret",
	add_to_participant: "Legg til deltager",
	add_to_participant_success: "Ny deltager er lagt til",
	add_to_participant_error: "Kunne ikke legge til deltager",
	already_enrolled: "Påmelding er allerede registrert til dette kurset.",
	convert_to_participant_message: "Vil du konvertere påmelding til deltager?",
	force_accept: "Legg til som ny elev",
	merge_title: "Slå sammen selskaper",
	merge_sub: "Velg selskap data skal overføres til",
	merge_confirm: "Selskaper og all tilhørende data vil bli slått sammen. Denne handlingen kan ikke revereseres! Vil du fortsette?",
	no_company_selected: "Velg selskap",
	merge_success: "Selskaper er blitt slått sammen",
	merge_failed: "Sammenslåing feilet",
	merge: "Slå sammen",
	search: "Søk",
	enrol: "Meld på",
	image_participant: "Elevbilde",
	image_enrolment: "Fra påmelding",
	status: "Status",
	single_enrolment_successful: "Vellykket påmelding.",
	single_enrolment_failed: "Påmelding av valgte elever feilet.",
	multi_enrolment_successful: "Valgte elever er meldt på kurs.",
	multi_enrolment_successful_with_skip: "Valgte elever er meldt på kurs. Noen var allerede påmeldt og vil ikke bli lagt til.",
	multi_enrolment_failed: "Påmelding for valgte elever har feilet",
	vat_invalid: "Selskap {name}  med dette orgnr. er allerede registrert.",
	select_course_title: "Velg kurs",
	merge_th_field: "Felt",
	merge_th_enrolment: "Påmelding",
	merge_th_participant: "Deltager/elev",
	merge_th_result: "Resultat",
	active_enrolments_cannot_delete: "There is an active enrolment(s). Cannot delete company.",
	original_course: "Original Course",
	select_enrolment_type: "Meld på som",
	payment_method: "Betalingsmåte",
	mapped_to: "Automatisk sammenslåing med elev med ID:",
	departments: "Avdelinger",
	department: "Avdeling",
	new_department: "Ny avdeling",
	edit_department: "Endre avdeling",
	employee_user_access: "Vil du gi tilgang for {first_name} {last_name} til {company_name}?",
	employee_user_remove: "Vil du fjerne tilgang for {first_name} {last_name} til {company_name}?",
	enrolment_edit: "Endre påmelding",
	enrolment_updated: "Påmelding endret",
	multiple_companies: "Flere selskaper",
	create_attendee_enrolment: "Ny påmelding",
	edit_attendee_enrolment: "Rediger påmelding",
	select_department: "Velg avdeling",
	company_admin: "Selskap admin",
};
export default enrolments;